import derechosDeberesPdf from '../../pdfs/derechos-deberes.pdf';
import Container from '../../components/shared/Container';
import PageHero from '../../components/shared/PageHero';
import quejasYReclamacionesImage from '../../images/quejasyreclamaciones.jpg';
import styles from './ReclamacionesYQuejasPage.module.css';

const OFICINA_VIRTUAL_URL = 'https://www.ovrmatepss.es/virtual/';

export default function ReclamacionesYQuejasPage() {
  return (
    <>
      <PageHero
        breadcrumb={[{ label: 'Inicio', to: '/' }, { label: 'Reclamaciones y quejas' }]}
        title="Reclamaciones y quejas"
        subtitle="Canales oficiales para comunicar incidencias, reclamaciones y oportunidades de mejora en la atencion prestada por Solimat."
        image={null}
      />

      <Container as="section" className={styles.section}>
        <article className={styles.mainCard}>
          <div className={styles.copy}>
            <p>
              En el marco de mejora continua de los servicios y de satisfaccion de los mutualistas y trabajadores
              protegidos, Solimat pone a disposicion de los usuarios que quieran exponer su disconformidad con el
              servicio prestado o poner de manifiesto una deficiencia, las siguientes vias de comunicacion:
            </p>

            <p className={styles.itemLead}>
              <span className={styles.bullet} aria-hidden="true" />
              <a className={styles.linkStrong} href={OFICINA_VIRTUAL_URL} target="_blank" rel="noopener noreferrer">
                Oficina Virtual de Reclamaciones
              </a>{'\u00A0'}
              del Ministerio de Inclusion, Seguridad Social y Migraciones.
            </p>
            <p>
              El Ministerio de Inclusion, Seguridad Social y Migraciones tiene habilitada la Oficina Virtual de
              Reclamaciones, que tiene por objeto el analisis y tratamiento de las quejas formuladas por los
              trabajadores en relacion con la actuacion de las Mutuas Colaboradoras con la Seguridad Social.
            </p>
            <p>
              La Direccion General de Ordenacion de la Seguridad Social centraliza las reclamaciones recibidas y las
              remite a la mutua correspondiente para que emita un informe sobre los hechos y circunstancias de la
              reclamacion, asi como su consideracion sobre la misma.
            </p>

            <p className={styles.itemLead}>
              <span className={styles.bullet} aria-hidden="true" />
              <strong>Hojas de Reclamaciones a disposicion de los interesados en todos los centros de SOLIMAT.</strong>
            </p>
            <p>
              Todas las personas interesadas tienen a su disposicion hojas de reclamaciones en los centros de Solimat.
            </p>
            <p>
              En estos casos, la mutua da contestacion directamente a las reclamaciones y quejas que reciba y las
              comunica, junto con la respuesta dada, a la Direccion General de Ordenacion de la Seguridad Social,
              organo de direccion y tutela de las mutuas.
            </p>
            <p>
              En este enlace puede consultar la carta de{' '}
              <a className={styles.linkStrong} href={derechosDeberesPdf} target="_blank" rel="noopener noreferrer">
                derechos y deberes del paciente
              </a>
              .
            </p>
          </div>

          <div className={styles.media}>
            <img src={quejasYReclamacionesImage} alt="Atencion de reclamaciones y quejas" />
          </div>
        </article>
      </Container>
    </>
  );
}
